import cls from 'classnames';
import React from 'react';

export const Tag = ({blueTag, className, title}: { blueTag: boolean, className?: string, title: string }) => (
    <div className={cls(className, 'inline-flex text-white text-base font-semibold rounded-tags px-4 py-1 w-fit',blueTag ? 'bg-brand-blue' : 'bg-brand-red')}>
        {title}
    </div>
);

